/**
 * pistasDelArchivo.js — lo que el nombre de un archivo deja adivinar.
 *
 * Quien sube una transcripción tiene que decir de qué reunión es y de qué día,
 * porque eso no está dentro del archivo. Pero casi siempre está en su NOMBRE:
 * los exportadores de Teams y Zoom lo ponen ahí, y quien guarda el archivo a
 * mano suele escribirlo también.
 *
 * La fecha importa más de lo que parece. Si se propone la de hoy, quien sube
 * una transcripción de hace tres semanas se lleva un acta mal fechada, y eso no
 * se nota hasta que ya está firmada. Mejor proponer la del nombre y que la
 * corrija quien quiera, que proponer siempre hoy y que nadie se fije.
 *
 * Vive aparte del diálogo para poder probarse: son dos funciones de texto puro
 * y no necesitan un navegador para decir si aciertan.
 */

/**
 * Un título de partida a partir del nombre del archivo.
 *
 * «Comite de direccion 2026-03-14.vtt» → «Comite de direccion». Se le quita la
 * extensión, la fecha y los separadores, porque lo que queda suele ser el
 * título de verdad y volver a escribirlo es trabajo regalado.
 */
export function tituloDesdeNombre(nombre) {
  return String(nombre || '')
    .replace(/\.[a-z0-9]{2,5}$/i, '')
    .replace(/\d{4}[-_]?\d{2}[-_]?\d{2}/g, ' ')
    .replace(/[_-]+/g, ' ')
    .replace(/\s{2,}/g, ' ')
    .trim();
}

/**
 * La fecha que trae el nombre, si la trae y es una fecha de verdad.
 *
 * Se comprueban mes y día porque un número con pinta de fecha no siempre lo es
 * —un identificador largo puede pasar por el patrón—, y una fecha imposible en
 * el campo sería peor que la de hoy: al menos hoy se ve raro y se corrige.
 */
export function fechaDesdeNombre(nombre) {
  const m = String(nombre || '').match(/(20\d{2})[-_]?(\d{2})[-_]?(\d{2})/);
  if (!m) return null;

  const [, anio, mes, dia] = m;
  if (Number(mes) < 1 || Number(mes) > 12) return null;
  if (Number(dia) < 1 || Number(dia) > 31) return null;

  return `${anio}-${mes}-${dia}`;
}

const pistasDelArchivo = { tituloDesdeNombre, fechaDesdeNombre };
export default pistasDelArchivo;
